// src/data/services.js
// Central data source – edit here to update every section

import { Link } from 'react-router-dom';

export const NAV_LINKS = [
  { label: 'Home',        href: '/' },
  { label: 'Services',    href: '#services',      active: true },
  { label: 'About Us',    href: '#about' },
  { label: 'Contacts Us', href: '#contact' },
];

export const FEATURES = [
  {
    icon: '📧',
    title: 'Inbox to Invite',
    desc:  'Emailing that books real conversations',
  },
  {
    icon: '📞',
    title: 'Dials to Discovery',
    desc:  'Calling that opens real conversations',
  },
  {
    icon: '🔗',
    title: 'Full Spectrum Outreach',
    desc:  'High-quality emails & calls working together',
  },
  {
    icon: '🚀',
    title: 'Reach at Scale',
    desc:  'Book more meetings across every channel',
  },
  {
    icon: '🎯',
    title: 'Outcome-Driven',
    desc:  'You pay only for qualified results',
  },
];

export const SERVICES = [
  {
    icon:  '📧',
    label: 'Email Outreach',
    title: 'Inbox to Invite',
    desc:  'We craft highly-targeted email campaigns designed to spark interest and secure real meetings. Personalized, relevant, and designed to get your prospects engaged. ',
    href:  '#email-detail',
  },
  {
    icon:  '📞',
    label: 'Phone Outreach',
    title: 'Dials to Discovery Calls',
    desc:  'Our team connects with the right decision-makers over the phone, setting up meaningful discovery calls. No gatekeepers, no wasted numbers just qualified conversations that move your pipeline forward. ',
    href:  '#phone-detail',
  },
  {
    icon:  '🔗',
    label: 'Multi-Channel',
    title: 'Full Spectrum Outreach',
    desc:  'Want the best of both worlds? We coordinate email and phone campaigns so your outreach is cohesive, effective, and maximizes engagement across channels. ',
    href:  '#multi-detail',
  },
  {
    icon:  '🚀',
    label: 'Growth',
    title: 'Reach at Scale',
    desc:  'For teams that want to accelerate their pipeline, we combine smart targeting with higher volumes of emails and calls. Each message is still relevant and personalized, ensuring more meetings without wasted effort.',
    href:  '#growth-detail',
  },
  {
    icon:  '🎯',
    label: 'Performance',
    title: 'Outcome-Driven Outreach',
    desc:  'This is our risk-free, ROl-focused option. We manage outreach, set discovery calls, and categorize them by engagement level. You only pay for the calls that meet agreed outcomes, ensuring maximum value for your investment.',
    href:  '#outcome-driven-detail',
  },
];


export const SERVICESLIST = [
  {
    icon:  '📧',
    label: 'Email Outreach',
    title: 'Inbox to Invite',
    para: 'Inbox to Invite is for teams that care deeply about quality over quantity. We design and run personalized email outreach that feels relevant, human, and worth responding to so conversations actually start. We don\'t believe in generic templates or mass blasting. Every campaign is built around who you want to talk to and why they should care.',
    desc:  [
      'Ideal customer profile (ICP) and smart audience targeting',
    'Personalized email messaging and sequences',
    'Account and prospect-level research',
    'Reply handling and lead nurturing',
    'Calendar scheduling with qualified prospects'
    ],
    href:  'https://demo.inviteengine.com/contactus/',
  },
  {
    icon:  '📞',
    label: 'Phone Outreach',
    title: 'Dials to Discovery Calls',
    para: 'Dials to Discovery Calls is designed for teams that believe real conversations still happen on the phone. We focus on connecting directly with decision-makers and setting up meaningful discovery calls not just logging dials. No wasted numbers. No gatekeepers. No spray-and-pray calling.',
    desc:  [
      'Smart targeting and call list building',
      'Strategic calling sequences (not random dialing)',
      'Direct outreach to decision-makers',
      'Live qualification before booking meetings',
      'Discovery call scheduling with context shared'
    ],
    href:  'https://demo.inviteengine.com/contactus/',
  },
  {
    icon:  '🔗',
    label: 'Multi-Channel',
    title: 'Full Spectrum Outreach',
    para: 'High-quality emails and calls working together to book more meetings Full Spectrum Outreach combines the best of Inbox to Invite and Dials to Discovery Calls. It\'s for teams that want a coordinated, multi-channel approach where email warms the lead and calls deepen the conversation.',
    desc:  [
      'Smart targeting and ICP definition',
      'Personalized email outreach campaigns',
      'Strategic calling aligned with email sequences',
      'Coordinated follow-ups across channels',
      'Qualified meeting scheduling with decision-makers',
    ],
    href:  'https://demo.inviteengine.com/contactus/',
  },
  {
    icon:  '🚀',
    label: 'Growth',
    title: 'Reach at Scale',
    para: 'More outreach. More conversations. More meetings. Reach at Scale is built for teams that want speed and volume, without going fully generic. We increase outreach across email and calls while still using smart targeting and light customization to stay relevant.',
    desc:  [
      'Smart targeting by role, industry, and region',
      'Higher-volume email and calling campaigns',
      'Light personalization for relevance',
      'Rapid meeting booking and pipeline coverage',
      'Ongoing optimization based on response data',
    ],
    href:  'https://demo.inviteengine.com/contactus/',
  },
  {
    icon:  '🎯',
    label: 'Performance',
    title: 'Outcome-Driven Outreach',
    para: 'We schedule and qualify discovery calls you pay only for results Outcome-Driven Outreach is for teams that want a performance-based model. We manage outreach, schedule discovery calls, and qualify them and you\'re charged based on the outcome of the first call, not effort or volume. Lower risk. Clear ROI. Full transparency.',
    desc: [
      'End-to-end outreach and meeting setup',
      'Smart targeting and qualification upfront',
      'Discovery call categorization (e.g. education call, high-intent call, active buyer)',
      'Clear outcome definitions agreed in advance',
      'Performance-based billing aligned to call quality', 
    ],
    href:  'https://demo.inviteengine.com/contactus/',
  },
];
